import { BN } from '@coral-xyz/anchor';
import { PublicKey, TransactionInstruction } from '@solana/web3.js';

export type SugarMoneyPdaType = {
  publicKey: PublicKey;
  nonce: number;
};

export interface SugarMoneyStateAccountType {
  bump: number;
  version: number;
  data: SugarMoneyStateDataV1AccountType;
}

export interface SugarMoneyStateDataV1AccountType {
  initialized: boolean;
  authority: PublicKey;
  pendingAuthority: PublicKey;
  wrapperMint: PublicKey;
  feeReceiver: PublicKey;
  feeBps: BN;
  initialVirtualTokenReserve: BN;
  initialVirtualSolReserve: BN;
  coinLotSize: BN;
  pcLotSize: BN;
  solventWrapper: BN;
  migrator: PublicKey;
  migrationCount: BN;
  migrationRefund: BN;
}

export interface SugarMoneyCurveAccountType {
  bump: number;
  version: number;
  data: SugarMoneyCurveDataV1AccountType;
}

export interface SugarMoneyCurveDataV1AccountType {
  completed: BN;
  realTokenReserve: BN;
  realSolReserve: BN;
  virtualTokenReserve: BN;
  virtualSolReserve: BN;
  migrationKind: SugarMoneyMigrationKindEnum;
}

export type SugarMoneyTradeParamsType = {
  tradeType: SugarMoneyTradeTypeEnum;
  amountToTrade: BN;
  tradeDirection: SugarMoneyTradeDirectionEnum;
  slippage?: number;
  mint?: PublicKey;
  receiver?: PublicKey;
};

export type SugarMoneyTradeInfoType = {
  ix?: TransactionInstruction;
  inputAmount: BN;
  minmaxOutputAmount: BN;
  price: BN;
  fee: BN;
};

export enum SugarMoneyTradeTypeEnum {
  ExactIn,
  ExactOut,
  MaxOut,
}

export enum SugarMoneyTradeDirectionEnum {
  Buy,
  Sell,
}

export enum SugarMoneyMigrationKindEnum {
  pSol = 'pSol',
  wSol = 'wSol',
}

export function decodeMigrationKind(decodeEnum: any): SugarMoneyMigrationKindEnum {
  if ('pSol' in decodeEnum) return SugarMoneyMigrationKindEnum.pSol;
  if ('wSol' in decodeEnum) return SugarMoneyMigrationKindEnum.wSol;
  throw new Error('Invalid migrationKind variant');
}

export function encodeMigrationKind(value_: SugarMoneyMigrationKindEnum): object {
  switch (value_) {
    case SugarMoneyMigrationKindEnum.pSol:
      return { pSol: {} };
    case SugarMoneyMigrationKindEnum.wSol:
      return { wSol: {} };
    default:
      throw new Error(`Invalid MigrationKindEnum value: ${value_}`);
  }
}
